import { gql } from "@apollo/client";

export default gql`
	query ($featureName: String!, $username: String) {
		isFeatureEnabled(featureName: $featureName, username: $username)
	}
`;
